(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name stationFlightHandling.controller:StationFlightHandlingCtrl
   *
   * @description
   *
   */
  angular
    .module('stationFlightHandling')
    .controller('StationFlightHandlingCtrl', StationFlightHandlingCtrl);

  function StationFlightHandlingCtrl(StationFlightHandlingService,$compile,$scope,$rootScope,$timeout,PopupManager,CommonMasterData,MessageService) {
    var vm = this;
    var hotSettingsLoaded = false;
    vm.ctrlName = 'StationFlightHandlingCtrl';
    console.log("Controller station flight handler:"+vm.ctrlName);
    vm.model = {
      width: window.screen.width,
      height:window.screen.height,
      stationFlightHandlingList: [],
      enableEdit:true,
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        station : null,
        flightNumber : null,
        pageSize: 100,
        startPosition: 0,
        flightLegId:null,
        fhrStatus: null

      },
      masterList : {
        flightNumberList : [{flightNumber:"01"},{flightNumber:"02"},{flightNumber:"03"}],
        airPorts:null,
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        crewIdsInvalid : false,
        isCrewIdsLoaded : false,
        haveNextPage:false,
        enableNextButton:false,
        tempStations : [],
        tempFHRStatus : [],
        FHRStatusList : [{statusDesc:"Complete",statusCode:"COM"},{statusDesc:"Partially Complete",statusCode:"PAR"},{statusDesc:"Incomplete",statusCode:"INC"}]
      },
      initialSearchDone : false,

    };

    //init functions
    //loadStationList();
    searchOnLoad();
    loadStation();
    //init functions end

    //search functions
    $rootScope.$on("OnSaveSFH", function () {
      loadData(true,true);
    });
    // toggle search

    function searchOnLoad(){
      loadData(false,true);
    }

    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
    };

    function loadData(onSave,onSearch) {
      if(onSearch){
        vm.model.stationFlightHandlingList=[];
        vm.model.searchCriteria.startPosition=0;
      }
      prepareStationArrayForSearch();
      StationFlightHandlingService.searchStationFlightHandlingData(vm.model.searchCriteria,
        function (serachData) {
          vm.model.enableEdit = serachData.editEnabled;
          vm.model.masterList.haveNextPage = serachData.nextPage;
          vm.model.searchCriteria.station =vm.model.masterList.tempStations;
          vm.model.searchCriteria.fhrStatus = vm.model.masterList.tempFHRStatus;
          if(!onSave){
            vm.model.searchPanelToggle = false;
          }
          vm.model.initialSearchDone = false;
          if(serachData.errors != null){
            MessageService.error(serachData.errors);
          }else{
            showDataInTable(serachData.responseData);
          }
          console.log(vm.model.searchCriteria.station);
        },function (error) {
          console.log(error);
          MessageService.error(error);
        });
    }

    function loadStation() {
      console.log("called Station");
      StationFlightHandlingService.getStationFlightHandlingStationForSearch(
        function (station) {
          vm.model.masterList.airPorts = station;

        },function (error) {
          console.log("Error Station Loaded")
          MessageService.error(error);
        });
    }

    function prepareStationArrayForSearch(){
      vm.model.masterList.tempStations=vm.model.searchCriteria.station;
      vm.model.masterList.tempFHRStatus=vm.model.searchCriteria.fhrStatus;
      var temp=[];
      angular.forEach(vm.model.searchCriteria.station, function(value, key){
        this.push(value.paramValue);
      },temp)
      vm.model.searchCriteria.station = temp;
      vm.model.searchCriteria.fhrStatus = (vm.model.searchCriteria.fhrStatus != null ) ? vm.model.searchCriteria.fhrStatus.statusCode : null;

    }

    vm.loadNext = function(){
      vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition +(vm.model.searchCriteria.pageSize);
      if(vm.model.stationFlightHandlingList.length>(vm.model.searchCriteria.startPosition)){
        showDataInTable(null);
      }else{
        loadData(false,false);
      }
    }

    vm.loadPrevious = function(){
      if(vm.model.searchCriteria.startPosition>1){
        vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition - (vm.model.searchCriteria.pageSize);
        vm.model.masterList.enableNextButton = true;
        showDataInTable(null);
      }
    }


    vm.onStationChange = function(station){
      console.log(station);

    }

    // submit search
    vm.submitSearch = function(params) {
      prepareSearchDetails();
      if(onDateChange()){
        loadData(false,true);
      }

    };

    function prepareSearchDetails(){
      if(vm.model.searchCriteria.flightNumber !== null)
        vm.model.searchCriteria.flightNumber = vm.model.searchCriteria.flightNumber;

    }

    function validateCrewIdsAndSearch(param) {
      param.crewIds = '';
      if (typeof vm.model.masterList.crewIdList != 'undefined') {
        for( var i = 0; i < vm.model.masterList.crewIdList.length; i++){
          if (i === 0) {
            param.crewIds = vm.model.masterList.crewIdList[i].crewId;
          }
          else {
            param.crewIds = param.crewIds + "," + vm.model.masterList.crewIdList[i].crewId;
          }
        }
      }

    }


    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (vm.model.masterList.toDateFormatInvalid
        || vm.model.masterList.fromDateFormatInvalid) {
        return false;
      } else if (istoDateBeforeFromDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
        return false;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
        if (!!vm.model.searchCriteria.crewType
          && !!vm.model.searchCriteria.crewType.crewTypeCode) {
          return true;
        }
        return false;
      }
    }

    function  onDateChange() {
      if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
          return false;
      }else{
        vm.model.masterList.fromDateAfterToDate = false;
        return true;
      }
    }

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    // check from date and to date
    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    }

    //load station list
    function loadStationList(){
      CommonMasterData.getAirportList(function (airportList) {
        vm.model.masterList.airPorts = airportList;
      }, function (error) {})



    }

    //search functions are end




    var dataObject = [];
    var hotSettings = [];
    var hot;


    vm.dataObject = function () {
      var dataObject = [];
      var i=parseInt(vm.model.searchCriteria.startPosition);
      var endNumber = (vm.model.stationFlightHandlingList.length - (i +(vm.model.searchCriteria.pageSize-1)))>=0? i+(vm.model.searchCriteria.pageSize):i+vm.model.stationFlightHandlingList.length%(vm.model.searchCriteria.pageSize);

      for (i; i<endNumber; i++) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          FLIGHT_NO : vm.model.stationFlightHandlingList[i].flightNumber,
          FLIGHT_DATE : (vm.model.stationFlightHandlingList[i].flightDate === null)?null:vm.model.stationFlightHandlingList[i].flightDate.split(" ")[0],
          ORIGIN: vm.model.stationFlightHandlingList[i].origin,
          DESTINATION: vm.model.stationFlightHandlingList[i].destination,
          PREV_FLT_FLIGHT_NO : vm.model.stationFlightHandlingList[i].prevFltNumber,
          PREV_FLT_EST_ARRIVAL_TIME:(vm.model.stationFlightHandlingList[i].prevFltOriginalEstArrivalDateTime === null)?null: modifyShowingPrevTime(vm.model.stationFlightHandlingList[i].prevFltOriginalEstArrivalDateTime,vm.model.stationFlightHandlingList[i].flightDate),
          PREV_FLT_RSTA:(vm.model.stationFlightHandlingList[i].prevFltEstArrivalDate === null)?null:modifyShowingPrevTime(vm.model.stationFlightHandlingList[i].prevFltEstArrivalDate,vm.model.stationFlightHandlingList[i].flightDate),
          PREV_FLT_ACT_ARRIVAL_TIME:(vm.model.stationFlightHandlingList[i].prevFltActArrivalDate === null)?null:modifyShowingPrevTime(vm.model.stationFlightHandlingList[i].prevFltActArrivalDate,vm.model.stationFlightHandlingList[i].flightDate),
          EST_DEPRATURE_TIME: vm.model.stationFlightHandlingList[i].originalEstDepartureDateTime,
          //EST_ARRIVAL_TIME: vm.model.stationFlightHandlingList[i].originalEstArrivalDateTime,
          ACT_DEPARTURE_TIME: vm.model.stationFlightHandlingList[i].actDepartureDateTime,
          //ACT_ARRIVAL_TIME: vm.model.stationFlightHandlingList[i].actArrivalDateTime,
          RSTD:vm.model.stationFlightHandlingList[i].estDepartureDateTime,
          //RSTA:vm.model.stationFlightHandlingList[i].estArrivalDateTime,
          AIRCREAFT_REG_NAME: vm.model.stationFlightHandlingList[i].aircraftRegName,
          AIRCRAFT_CAPACITY: vm.model.stationFlightHandlingList[i].modelNumber,
          P_COUNT: vm.model.stationFlightHandlingList[i].actAdult+ vm.model.stationFlightHandlingList[i].actChild+ vm.model.stationFlightHandlingList[i].actInfant,
          GROUND_TIME: vm.model.stationFlightHandlingList[i].groundTime,
          GATE: vm.model.stationFlightHandlingList[i].gate,
          MODIFIED_DATE:(vm.model.stationFlightHandlingList[i].modifiedDate === null)?null:vm.model.stationFlightHandlingList[i].modifiedDate,
          TOTAL_DELAY: vm.model.stationFlightHandlingList[i].totalDelay,
        })
      }

      if(vm.model.masterList.haveNextPage){
        vm.model.masterList.enableNextButton = true;
      }else{
        if((vm.model.stationFlightHandlingList.length - (vm.model.searchCriteria.startPosition +(vm.model.searchCriteria.pageSize)))<1){
          vm.model.masterList.enableNextButton = false;
        }else{
          vm.model.masterList.enableNextButton = true;
        }
      }
      return dataObject;
    };

    function modifyShowingPrevTime(prevFltDate,curFltDate){
      if(prevFltDate !== null){
        var date2 = getAdaptedDate(prevFltDate.split(" ")[0]);
        var date1 = getAdaptedDate(curFltDate.split(" ")[0]);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        var dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if(dayDifference !== 0){
            return prevFltDate.split(" ")[1]+" (-"+dayDifference+")";
        }else{
          return prevFltDate.split(" ")[1];
        }
      }else{
        return null;
      }

    }

    function getAdaptedDate(date){
      var returnDate = new Date(date.split("/")[2],date.split("/")[1]-1,date.split("/")[0]);
      return returnDate;
    }

    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        scrollH: 'auto',
        scrollV: 'auto',
        width: vm.model.width * 0.98,
        autoWrapRow: true,
        height: vm.model.height * 0.68,
        rowHeaders: true,
        contextMenu: false,
        manualColumnResize: true,
        copyRowsLimit: 1000000,
        // colWidths: [vm.model.width * 0.05, vm.model.width * 0.15, vm.model.width * 0.1, vm.model.width * 0.195, vm.model.width * 0.15, vm.model.width * 0.4, vm.model.width * 0.15],
        colWidths: [60,70,100,60,80,70,70,70,100,100,100,80,80,80,95,120,140,100,160],
        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true
          },
          {
            data: 'FLIGHT_NO',
            type: 'text',
            className: 'htCenter htMiddle',
            renderer:vm.orangeRedTextRender,
            readOnly: true
          },
          {
            data: 'FLIGHT_DATE',
            renderer: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'ORIGIN',
            type: 'text',
            className: 'htCenter htMiddle',
            renderer:vm.blueTextRender,
            readOnly: true
          },
          {
            data: 'DESTINATION',
            type: 'text',
            className: 'htCenter htMiddle',
            renderer:vm.blueTextRender,
            readOnly: true
          },
          {
            data: 'EST_DEPRATURE_TIME',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'RSTD',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'ACT_DEPARTURE_TIME',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'TOTAL_DELAY',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'P_COUNT',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'GROUND_TIME',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'PREV_FLT_EST_ARRIVAL_TIME',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'PREV_FLT_RSTA',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'PREV_FLT_ACT_ARRIVAL_TIME',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'PREV_FLT_FLIGHT_NO',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'AIRCREAFT_REG_NAME',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'AIRCRAFT_CAPACITY',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'GATE',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          },
          {
            data: 'MODIFIED_DATE',
            type: 'text',
            className: 'htCenter htMiddle',
            readOnly: true
          }

        ],
        colHeaders: [
          '',
          'Flight No',
          'Flight Date',
          'Origin',
          'Destination',
          'STD',
          'RSTD',
          'ATD',
          'Total Delay',
          'Passengers',
          'Ground Time',
          'Prev STA',
          'Prev RSTA',
          'Prev ATA',
          'Prev Flt No',
          'AC Reg ',
          'AC Type',
          'Gate/Bay',
          'Last Updated',

        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');

    //  popup open
    vm.openPopUP = function (rowNo,editable) {
      vm.model.searchCriteria.fhrStatus = (vm.model.masterList.tempFHRStatus != null ) ? vm.model.masterList.tempFHRStatus.statusCode : null;
      vm.model.searchCriteria.flightLegId = vm.model.stationFlightHandlingList[rowNo+(vm.model.searchCriteria.startPosition)].flightLegId;
      StationFlightHandlingService.searchStationFlightHandlingData(vm.model.searchCriteria,
        function (resData) {
          const popUpObj = resData.responseData[0];
          popUpObj.editEnabled = editable;
          vm.model.searchCriteria.flightLegId = null;
          vm.model.searchCriteria.fhrStatus = vm.model.masterList.tempFHRStatus;
          PopupManager.openModal('STATION_FLIGHT_HANDLING_POPUP',popUpObj, null);
        },function (error) {
          console.log(error);
          MessageService.error(error);
        });

    };



    function showDataInTable(data) {
      if(data != null){
        if(!vm.model.stationFlightHandlingList.length){
          vm.model.stationFlightHandlingList = data;
        }else{
          vm.model.stationFlightHandlingList =  vm.model.stationFlightHandlingList.concat(data);
        }
      }
      dataObject = vm.dataObject();
      hotSettings = vm.hotSettings();
      hot = new Handsontable(hotElement, hotSettings);
      if(!hotSettingsLoaded){

        if(vm.model.enableEdit){
          hot.updateSettings({
            contextMenu: {
              callback: function (key, options) {
                if (key === 'edit') {
                  vm.openPopUP(hot.getSelected()[0],true);
                }
                else if (key === 'View') {
                  vm.openPopUP(hot.getSelected()[0],false);
                }
              },
              items: {
                "edit": {name: 'Edit',
                hidden: function() {
                  return vm.model.stationFlightHandlingList[hot.getSelected()[0]].editable != "Y";
                }
                },

                "View": {name: 'View Only',
                  hidden: function() {
                    return vm.model.stationFlightHandlingList[hot.getSelected()[0]].editable == "Y";
                  }
                }

              }
            }
          })
        }else{
          hot.updateSettings({
            contextMenu: {
              callback: function (key, options) {
                if (key === 'View') {
                  vm.openPopUP(hot.getSelected()[0],false);
                }

              },
              items: {
                "View": {name: 'View Only'},
              }
            }
          })
        }

        hotSettingsLoaded = true;

      }

      $compile(hotElement)($scope);
      console.log("Show table end");
    }

    vm.orangeRedTextRender = function (instance, td, row, col, prop, value) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);
      if(vm.model.stationFlightHandlingList[row+(vm.model.searchCriteria.startPosition)].totalDelay !== null){
        var delay = parseInt(vm.model.stationFlightHandlingList[row+(vm.model.searchCriteria.startPosition)].totalDelay);
        if(delay>5 && delay<15){
          td.style.color = 'orange';
        }
        else if(14<delay){
          td.style.color = 'red';
        }
      }

    };

    vm.greenBGRender = function (instance, td, row, col, prop, value) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);
      if(vm.model.stationFlightHandlingList[row+(vm.model.searchCriteria.startPosition)].mandatory){
        td.style.backgroundColor= '#96FF8F';
      }
    };

    vm.blueTextRender = function (instance, td, row, col, prop, value) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);
      if(vm.model.stationFlightHandlingList[row+(vm.model.searchCriteria.startPosition)].editable == "Y"){
        td.style.color = 'blue';
      }
      if(vm.model.stationFlightHandlingList[row+(vm.model.searchCriteria.startPosition)].modifiedDate !== null){
        if(vm.model.stationFlightHandlingList[row+(vm.model.searchCriteria.startPosition)].mandatory){
          td.style.backgroundColor= '#96FF8F';
        }else{
          td.style.backgroundColor= '#9DCEFA';
        }
      }
    };

  }
}());


